export default __webpack_public_path__ + "assets/svg/MiniBand.d5bb726169cd9daf0a91ca775567642f.svg";